import api from './api';

export interface PaymentCheckoutRequest {
  package_type: string;
  success_url?: string;
  cancel_url?: string;
}

export interface PaymentCheckoutResponse {
  checkout_url: string;
  checkout_id?: string;
}

export interface SubscriptionPackage {
  package_type: string;
  name: string;
  monthly_tokens: number;
  price: number;
  description: string;
}

export const paymentService = {
  async createCheckout(request: PaymentCheckoutRequest): Promise<PaymentCheckoutResponse> {
    const response = await api.post<PaymentCheckoutResponse>('/payment/checkout', request);
    return response.data;
  },

  async getPackages(): Promise<{ packages: SubscriptionPackage[] }> {
    const response = await api.get<{ packages: SubscriptionPackage[] }>('/payment/packages');
    return response.data;
  },
};



